import { Navigate, Outlet } from 'react-router';
import { Sidebar } from '@/features/sidebar';
import { Header } from '@/features/header';
import { BottomBar } from '@/features/bottom-bar/BottomBar';
import { useProfileQuery } from '@/models/user';
import { Role } from '@/models/auth';

export const PartnerLayout = () => {
  const { data } = useProfileQuery();

  if (!data) {
    return <Navigate to="/login" replace />;
  }

  if (data.role !== Role.TaxiPartner) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex flex-row h-screen w-screen bg-white pb-20 lg:pb-5">
      <div className="h-full border-gray-100 border-r hidden sm:block">
        <Sidebar role={data.role} />
      </div>
      <div className="fixed bottom-0 left-0 right-0 sm:hidden z-20">
        <BottomBar role={data.role} />
      </div>
      <div className="basis-auto grow overflow-y-auto">
        <div className="sticky top-0 z-20 mb-4 border-gray-100 border-b">
          <Header />
        </div>
        <div className="flex justify-center h-full w-full px-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
